var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    { on: { submit: _vm.submit } },
    [
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.price_book.price_book_select"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "5" }
            },
            [
              _c("price-book-select", {
                attrs: { "price-book-items": _vm.priceBookData },
                on: { "price-book-change": _vm.priceBookChange },
                model: {
                  value: _vm.salesForceInfo.oldStandardPriceBook2Id,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "oldStandardPriceBook2Id", $$v)
                  },
                  expression: "salesForceInfo.oldStandardPriceBook2Id"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.opportunity.product"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "5" }
            },
            [
              _c("product-select", {
                attrs: {
                  "price-book-id": _vm.salesForceInfo.oldStandardPriceBook2Id,
                  product: _vm.$t("Rehab Cloud Standard"),
                  disabled: _vm.isStandardPriceBook(
                    _vm.salesForceInfo.oldStandardPriceBook2Id
                  )
                },
                on: {
                  "price-change": _vm.oldStandardPriceChange,
                  "product-change": _vm.productChange,
                  "entry-change": _vm.entryChange
                },
                model: {
                  value: _vm.salesForceInfo.oldStandardProductId,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "oldStandardProductId", $$v)
                  },
                  expression: "salesForceInfo.oldStandardProductId"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t(
                              "view.contract_form.update.label.apply_info.start_date"
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-4 pb-0",
              attrs: { cols: "12", sm: "12", md: "2" }
            },
            [
              _c("date-picker-wrapper", {
                attrs: {
                  classes: "mt-0 pt-0 pb-0",
                  hint: _vm.$t(
                    "view.contract_form.update.hint.apply_info.start_date"
                  ),
                  placeholder: _vm.$t(
                    "view.contract_form.update.placeholder.apply_info.start_date"
                  ),
                  type: "month",
                  min: "2023-01-01",
                  max: "2024-03-01"
                },
                model: {
                  value: _vm.salesForceInfo.applyInfoOldStandardStartDate,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.salesForceInfo,
                      "applyInfoOldStandardStartDate",
                      $$v
                    )
                  },
                  expression: "salesForceInfo.applyInfoOldStandardStartDate"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.price"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "5" }
            },
            [
              _c("v-text-field", {
                staticClass: "mt-0 pt-0 pb-0",
                attrs: {
                  "persistent-hint": "",
                  disabled: "",
                  "error-messages": _vm.getPriceErrorMsg(),
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.contract.price_kobetu"
                  ),
                  autocomplete: "off",
                  type: "number",
                  suffix: _vm.$t("view.sales_force.reflect.label.contract.yen")
                },
                model: {
                  value: _vm.salesForceInfo.oldStandardPrice,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "oldStandardPrice", $$v)
                  },
                  expression: "salesForceInfo.oldStandardPrice"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3  align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.bunkatsu"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "8" }
            },
            [
              _c("v-checkbox", {
                staticClass: "mt-0",
                attrs: {
                  "persistent-hint": "",
                  "input-value": _vm.salesForceInfo.oldStandardBunkatuFlg,
                  value: _vm.$t(
                    "view.sales_force.reflect.data_labels.contract.bunkatsu.value"
                  ),
                  label: _vm.$t(
                    "view.sales_force.reflect.data_labels.contract.bunkatsu.label"
                  )
                },
                model: {
                  value: _vm.salesForceInfo.oldStandardBunkatuFlg,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "oldStandardBunkatuFlg", $$v)
                  },
                  expression: "salesForceInfo.oldStandardBunkatuFlg"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3  align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.it_flg"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "8" }
            },
            [
              _c("v-checkbox", {
                staticClass: "mt-0",
                attrs: {
                  "persistent-hint": "",
                  disabled: _vm.oldStandardItFlgDisabled,
                  "input-value": _vm.salesForceInfo.oldStandardItFlg,
                  value: _vm.$t(
                    "view.sales_force.reflect.data_labels.contract.it_flg.value"
                  ),
                  label: _vm.$t(
                    "view.sales_force.reflect.data_labels.contract.it_flg.label"
                  )
                },
                model: {
                  value: _vm.salesForceInfo.oldStandardItFlg,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "oldStandardItFlg", $$v)
                  },
                  expression: "salesForceInfo.oldStandardItFlg"
                }
              }),
              _vm._v(" "),
              _vm.oldStandardItFlgDescription
                ? _c("label", { staticClass: "caption red--text" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t(
                            "view.sales_force.reflect.msg.select_two_years_item"
                          )
                        ) +
                        "\n            "
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 fixed-label-area align-center",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold fixed-label ml-4" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.tokubetu_detail"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "8" }
            },
            [
              _c("v-textarea", {
                staticClass: "mt-0",
                attrs: {
                  outlined: "",
                  rows: "2",
                  "persistent-hint": "",
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.contract.tokubetu_detail"
                  )
                },
                model: {
                  value: _vm.salesForceInfo.oldStandardTokubetuDetail,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.salesForceInfo,
                      "oldStandardTokubetuDetail",
                      $$v
                    )
                  },
                  expression: "salesForceInfo.oldStandardTokubetuDetail"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        [
          _c("v-col", {
            staticClass: "ml-3 mb-0 mt-0 pt-3 pb-0",
            attrs: { cols: "12", sm: "12", md: "4" }
          }),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-3 pb-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    depressed: "",
                    block: true,
                    type: "submit",
                    color: "#11479B",
                    dark: true
                  },
                  on: { click: _vm.submit }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t(
                          "view.sales_force.reflect.button_caption.save_opportunity"
                        )
                      ) +
                      "\n            "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("simple-dialog", {
        attrs: {
          "show-dialog": _vm.showConfirmDialog,
          "max-width": "800",
          "default-msg": _vm.confirmMessage
        },
        on: {
          "ok-click": function($event) {
            return _vm.reflect()
          },
          "cancel-click": function($event) {
            return _vm.dialogClose()
          }
        }
      }),
      _vm._v(" "),
      _c("simple-dialog", {
        attrs: {
          "show-dialog": _vm.showAlertDialog,
          "max-width": "800",
          "is-confirm": false,
          "default-msg": _vm.alertMessage
        },
        on: {
          "ok-click": function($event) {
            return _vm.dialogClose()
          },
          "cancel-click": function($event) {
            return _vm.dialogClose()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26a968db", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26a968db","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sales_force/OpportunityOldStandardPre.vue
// module id = A/NN
// module chunks = 1